import { createTheme } from '@mui/material';
import { styled } from '@mui/system';
import { Card } from '@mui/material';

// 创建可重用的自定义主题
export const catTheme = createTheme({
  palette: {
    primary: {
      main: '#3C210E', // 主文本颜色
    },
    secondary: {
      main: '#a26438', // 强调色
    },
    background: {
      default: '#f5ebe0', // 页面背景
    },
  },
  typography: {
    fontFamily: [
      'Microsoft YaHei',
      'PingFang SC',
      'Hiragino Sans GB',
      'WenQuanYi Micro Hei',
      'sans-serif'
    ].join(','),
    h4: {
      fontWeight: 700,
      borderBottom: '2px solid #a26438',
      paddingBottom: '0.3rem',
      fontSize: '1.5rem',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    body2: {
      fontSize: '0.8rem',
      marginBottom: '0.3rem',
    },
  },
  components: {
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '12px',
          '&:last-child': {
            paddingBottom: '12px',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          height: '22px',
          fontSize: '0.7rem',
        },
      },
    },
  },
});

// 可重用的自定义卡片组件
export const BreedCard = styled(Card)(({ theme }) => ({
  transition: 'transform 0.2s, box-shadow 0.2s',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: theme.shadows[4],
  },
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

// 常用样式对象，可以在不同组件中重用
export const styles = {
  container: {
    padding: '1rem',
    backgroundColor: catTheme.palette.background.default,
  },
  pageTitle: {
    mb: 1,
  },
  gridContainer: {
    mt: 1,
  },
  cardContent: {
    flexGrow: 1,
    p: 1.5,
  },
  cardTitle: {
    mb: 0.5,
  },
  cardText: {
    mb: 0.5,
  },
  traitsContainer: {
    borderTop: '1px dashed #a26438',
    pt: 0.8,
    mt: 0.8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.5,
  },
  traitChip: {
    bgcolor: 'rgba(162,100,56,0.1)',
    color: 'primary.main',
    fontSize: '0.7rem',
    height: '20px',
  },
  comparisonSection: {
    marginTop: '2rem',
    padding: '1rem',
    backgroundColor: 'white',
    borderRadius: '8px',
  },
  comparisonTitle: {
    fontSize: '1.2rem',
    mb: 1,
  },
  comparisonText: {
    fontStyle: 'italic',
    mb: 1,
  },
};
